import {
  compileBlocklistPatterns,
  DEFAULT_REDDIT_BLOCKLIST_PATTERNS,
  parseBlocklistLines,
  type CompiledBlocklist,
} from './redditTitleFilter';
import type { NewsFeedPreferences } from './newsFeedDefaults';
import { getNewsFeedPreferences } from './newsFeedConfigState';

/** @deprecated Use NewsFeedPreferences — kept for import compatibility */
export type NewsPreferences = NewsFeedPreferences;

export { DEFAULT_NEWS_SUBREDDITS } from './newsFeedDefaults';

export function loadNewsPreferences(): NewsFeedPreferences {
  return getNewsFeedPreferences();
}

export function parseSubredditsInput(raw: string): string[] {
  return raw
    .split(/[\s,]+/)
    .map(s => s.trim().replace(/^\/?r\//i, ''))
    .filter(Boolean)
    .filter((s, i, arr) => arr.indexOf(s) === i && /^[A-Za-z0-9_]+$/.test(s));
}

export function formatSubredditsInput(subs: readonly string[]): string {
  return subs.join(', ');
}

export function compileNewsBlocklist(prefs: NewsFeedPreferences): CompiledBlocklist {
  const lines = parseBlocklistLines(prefs.blocklistText);
  return compileBlocklistPatterns(lines.length > 0 ? lines : [...DEFAULT_REDDIT_BLOCKLIST_PATTERNS]);
}
